import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getBusinessConfiguration = async (
  businessId,
  activeEmployerInfo = {}
) => {
  const apiPath = `business/${businessId}/get-business-configuration`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);
  return response.data;
};
